import {VerifyEnum} from '@/types/verify';

export type TExamCategory = 'fca' | 'fcp'; // 认证考试的类型
export enum TTimuType {
  objective_judge = 1, // 客观题-判断题
  objective_radio, // 客观题-单选题
  objective_checkbox, // 客观题-多选题
  subjective_upload, // 主观题-上传文件的
  subjective_writing, // 主观题-写答案的
  subjective_field, // 主观题-自定义字段
}

export type TExamFileItem = {
  id: string;
  file: string;
  fileName: string;
};

export type TTimuAttach = {
  id: string;
  size?: number;
  url: string;
  name: string;
  type: 1 | 2; // 1是图片 2是附件
};

export type Answer = {
  name?: any;
  size?: number;
  url?: string;
};

export type SubjectiveAnswerItem = {
  id: string;
  type: 'text' | 'attachment';
  value: string;
  answer?: Answer | null | any;
};

export type TTimu = {
  weigh: number; // 权重
  id: string;
  timuId: string;
  type: TTimuType; // 题目类型,
  typeLabel?: string;
  index: number; // 第几道题,
  title: string; // 题目,
  content?: string; // 题目描述的富文本，是主观题里需要的
  score: number | null; // 题目的分值
  frllScore?: number;
  onChange?: (value: any | undefined) => void;
  options?: {
    id: string;
    timuId: string;
    title: string;
    weigh: number;
  }[];
  attachments?: TTimuAttach[];
  error?: boolean; // 当前题目是否是错误状态 ，当点击交卷但没回答时报错
  defaultAnswer?: any; // 之前记录的答案
  answer?: any; // 之前记录的答案,
  categoryId: string; //题目分类的id
  categoryName: string; // 题目分类的名称
  categoryInfo?: string; // 题目分类的说明
  grouping: 0 | 1; // 题目分组方式
  subjectiveAnswer?: SubjectiveAnswerItem[]; // 自定义主观题
};
export type TCheckTimu = {
  subjectiveAnswer?: any;
  isTeacherCheck: boolean;
  weigh: number;
  categoryId: string;
  categoryName: string;
  grouping: 0 | 1;
  frllScore?: number;
  timuId: string;
  id: string;
  isCheck?: boolean; // 是否处于阅卷模式下
  type: TTimuType; // 题目类型,
  typeLabel?: string;
  index: number; // 第几道题,
  title: string; // 题目,
  content?: string; // 主观题的题目描述
  onChange?: (value: { comment: string; score: number }) => void;
  categoryInfo?: string; // 题目分类的说明
  options?: {
    id: string;
    timuId: string;
    title: string;
    weigh: number;
  }[];
  attachments?: TTimuAttach[];
  rightAnswer?: string; // 题目的正确答案
  analysis?: string; // 题目解析（可选富文本），仅查看试卷时随正确答案下发
  answer?: string; // 考生的答案正确答案,在主观题里就是老师的评语
  score: number | null; // 这道题的分值
  tempScore: number | null;
  tempComment: string | null;
  comment: string | null;
  studentAnswer?: string[] &
    TTimuAttach & { text: string } & {
    filename: string;
    fileurl: string;
    filesize: number;
  }; // 考生的答案,主观题里就是用户上传的文件或者用户写的文字
  teacherFindCheckData?: { score: number; comment: string }; // 之前保存的阅卷记录
};
export type TPreviewTimu = {
  isTeacherCheck?: boolean;
  weigh: number;
  grouping: 0 | 1;
  categoryId: string;
  categoryInfo?: string;
  categoryName: string;
  timuId: string;
  id: string;
  frllScore?: number;
  isCheck?: boolean; // 是否处于阅卷模式下
  type: TTimuType; // 题目类型,
  typeLabel?: string;
  index: number; // 第几道题,
  title: string; // 题目,
  comment: string | null;
  tempComment: string | null;
  content?: string; // 主观题的题目描述
  onChange?: (value: { comment: string; score: number }) => void;
  options?: {
    id: string;
    timuId: string;
    title: string;
    weigh: number;
  }[];
  attachments?: TTimuAttach[];
  rightAnswer?: string; // 题目的正确答案
  analysis?: string; // 题目解析（可选富文本），仅查看试卷时随正确答案下发
  answer?: string; // 考生的答案,主观题里就是用户上传的文件或者用户写的文字
  score: number | null; // 这道题的得分 0 没得分 null 没作答
  tempScore: number | null;
  teacherFindCheckData?: { score: number; comment: string }; // 之前保存的阅卷记录
  subjectiveAnswer?: any;
};

export enum TExamResultType {
  normal, // 正常交卷，交卷后需阅卷
  empty_have_change, // 白卷但是有补考机会
  empty_no_change, // 白卷没补考机会
  pass, // 全是客观题，过了
  no_pass, // 全是客观题，没过
}

export type TExamDetailFixedInfoType = {
  no_pass_tips: string;
  no_pass_link?: string;
  pass_tips: string;
  pass_link: any;
  leida_url: string; // 雷达图的图片路径
  signup_text: any[]; // pc端报名弹窗右边的文字
  fcrpd_text?: string[]; // fcrpd替他人报名的文字
  // outline_link?: string;
  // mock_paper_link?: string;
  // help_doc_link?: string;
  question_bank_url?: string;
  require: string;
  duration: string;
  method: string;
  subjects?: { label: string; price: string }[];
  exam_money: number;
  pass_condition: string;
  extra_tips?: { label: string; value: string }[];
};

// 考试的种类
export type TExamKind =
  | 'fcra'
  | 'fca_shuzhiniao'
  | 'fca_data_analysis'
  | 'fcp_data_analysis'
  | 'fcp_business_data_analysis'
  | 'fcrp'
  | 'fcrpd'
  | 'fcp_plugin'
  | 'fcba'
  | 'fcba5'
  | 'fcbp'
  | 'fcbp6'
  | 'fcaa'
  | 'fcap'
  | 'fcja'
  | 'fcjp'
  | 'fca_jiushuyun'
  | 'finedatalink' | 'fca_chatbi' | 'fca_ai' | 'ejc_l1';

export type TExamDetailFixedDataType = {
  cert_id: string;
  short_english_title: string;
  short_cn_title: string;
  certificate_title: string;
  type: TExamKind; // 考试的类型
  typeEnum: VerifyEnum;
  isProfession: boolean;
  extraTips?: {
    href: string;
    text: string;
  }; // 正文页面的通知条 可配置
  leftNavs: { label: string; href: string; english_label: string }[]; // 左侧三个导航的按钮
  documentTitle?: string; //显示相关学习资料还是其他自定义的
  noDocumentLeft?: boolean; // 是否要显示相关学习资料左边的内容
  noJobList?: boolean; // 是否隐藏右侧"企业招聘"模块（企业联合认证等不含招聘权益的认证使用）
  document: { label: string; href: string }[];
  exam_info: TExamDetailFixedInfoType;
  ability_demanded: {
    suit_people: string;
    reward: string;
    url?: string;
    text: string[];
  };
  title: string;
  english_title: string;
  intro: string;
  ad?: { url: string; href: string };
  qa?: { question: string; answer: string; id: number }[];
  // 企业联合认证（EJC）专属区块：考核范围与达标要求 / 认证体系
  ejc_themes?: {
    color: string; // 主题色圆点
    title: string; // 能力名
    pct: string; // 占比，如 30%
    mark: string; // 标记，如 证书标注 ① / 支撑能力
    scope: string; // 考核范围（html）
    standard: string; // 达标要求（html）
  }[];
  ejc_note?: string; // 考核说明（html，通过标准/依据/考纲版本）
  ejc_levels?: { lv: string; name: string; desc: string; on?: boolean }[];
  ejc_levels_note?: string;
};

// 考试报考的几种类型枚举
export enum ExamMethod {
  anytime, // 随时报考
  batchTime, // 按批次报考,
  myTime, // 按自己选择的时间开始
}

// 考试详情页的状态
export enum PlanStatus {
  noStart, // 没开始
  examing, // 考试中
  reviewing, // 阅卷中
  pass, // 通过
  noPass, // 没通过
  appealing, // 申诉中
  finished, //考试已结束，是一个不正常的状态
}

// fcrpd paperState的状态
export enum FcrpdPaperStatus {
  noStart, // 没开始
  examing, // 考试中
  noSubmitPaper, // 未交卷
  todoreview, // 待分配阅卷人
  reviewing, // 阅卷中
  todoPublish, // 待发布
  pass, // 通过
  noPass, // 没通过
  noPassNoAnswer, // 没通过白卷
  appealing, // 申诉中
}
